import { Component } from '@angular/core';
import { ICellRendererParams } from 'ag-grid';
import { ICellRendererAngularComp } from 'ag-grid-angular';
import { isNil as _isNil } from 'lodash';

/**
 * スケジュールイベントセルコンポーネント
 */
@Component({
  templateUrl: './schedule-event-cell.component.html',
  styleUrls: ['./schedule-event-cell.component.scss']
})
export class ScheduleEventCellComponent implements ICellRendererAngularComp {

  /**
   * サービスカラー
   */
  _itemServiceColor: string;

  /**
   * ラベル
   */
  _label: string;

  /**
   * @override
   */
  agInit(params: ICellRendererParams) {
    if (_isNil(params) || _isNil(params.data)) {
      return;
    }

    this._itemServiceColor = params.data.itemServiceColor;
    this._label = params.value;
  }

  /**
   * @override
   */
  refresh(_params: any): boolean {
    return false;
  }
}



// WEBPACK FOOTER //
// ./src/app/shared/schedule-event-cell/schedule-event-cell.component.ts